import { Vue, Component } from 'vue-property-decorator';


@Component({
    name: 'threshold',
})

export default class Threshold extends Vue {
    // ---------------------------------------------------------------------
    // Properties

    public getBackFlow() {
        this.$router.push('/dashboard');
    }
}
